
export enum HazmatBulkQuantityCd {
	BULK = 'Bulk',
	LIMITED_QUANTITY = 'Limited Quantity',
	NON_BULK = 'Non-Bulk'}

